import { Navigate } from 'react-router';

import { Capabilities } from '@/auth-capabilities';
import { ItemTable } from '@/components/queue/ItemTable';
import { MyItems } from '@/components/queue/MyItems';
import { RegionalAuthErrorBanner } from '@/components/RegionalAuthErrorBanner';
import { Alert } from '@/components/ui';
import { ApiRegion } from '@/config';
import { useAuth } from '@/context/appContext';
import { useFeatures } from '@/context/FeatureContext';
import { CombinedQueueProvider, useCombinedQueue } from '@/services/useCombinedQueue';

export const QueuePage = () => {
  const { hasAuth } = useAuth();
  const { queue_polling: queuePolling } = useFeatures();

  // Navigating during render is ignored, so redirect declaratively.
  if (!hasAuth(Capabilities.mpqItemView) || !queuePolling) {
    return <Navigate to="/foods" replace />;
  }

  return (
    <CombinedQueueProvider>
      <QueueLists />
    </CombinedQueueProvider>
  );
};

const QueueLists = () => {
  const { authInfo } = useAuth();
  const { items: queue, loading, partialFailure } = useCombinedQueue();

  return (
    <div
      className="grid min-w-0 max-w-full gap-6 overflow-x-auto"
      // biome-ignore lint/a11y/noNoninteractiveTabindex: scrollable region must be in the tab order
      tabIndex={0}
    >
      {/* One US auth banner for the whole feed; row scopes render none. */}
      <div className="empty:hidden">
        <RegionalAuthErrorBanner region={ApiRegion.US} />
      </div>
      {partialFailure && (
        <Alert tone="caution" role="alert">
          Some items couldn't load. Showing the items that are available.
        </Alert>
      )}
      <MyItems items={queue.filter(i => i.first_reviewer_user_id === authInfo?.reviewer_id)} loading={loading} />
      <ItemTable items={queue.filter(i => i.first_reviewer_user_id !== authInfo?.reviewer_id)} loading={loading} />
    </div>
  );
};
